export default "__VITE_ASSET__bxTDobt2__"